import React, { Fragment } from 'react';
import Header2 from '../../components/Header2/Header2';
import PageTitle from '../../components/pagetitle/PageTitle';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';

const TermsConditionsPage = () => {
    return (
        <Fragment>
            <Header2 />
            <main className="page_content">
                <PageTitle
                    pageTitle={'Terms & Conditions'}
                    pagesub={'Our service agreement'}
                    pageTop={'Legal'}
                />
                <section className="section_space bg-light">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div className="bg-white p-4 p-md-5 rounded-4 shadow-sm">
                                    <p className="mb-4">
                                        These Terms & Conditions govern the use of services provided by Krit and any related website, platform, or support channels. By engaging our company for software development, IT consulting, cloud, automation, or digital transformation services, you agree to the terms below.
                                    </p>

                                    <div className="mb-4">
                                        <h3 className="h5 mb-3">1. Scope of Services</h3>
                                        <p className="mb-0">
                                            Krit provides software development, web and mobile application solutions, IT consulting, cloud infrastructure setup, maintenance, cybersecurity support, and related digital services. Project deliverables, timelines, and responsibilities will be defined in a separate proposal, statement of work, or service agreement.
                                        </p>
                                    </div>

                                    <div className="mb-4">
                                        <h3 className="h5 mb-3">2. Client Responsibilities</h3>
                                        <p className="mb-0">
                                            Clients are responsible for providing accurate information, timely approvals, access to required systems, and any content or documentation needed to complete the project. Delays caused by incomplete input or unavailability of resources may affect timelines and delivery schedules.
                                        </p>
                                    </div>

                                    <div className="mb-4">
                                        <h3 className="h5 mb-3">3. Fees, Payment & Taxes</h3>
                                        <p className="mb-0">
                                            Fees for services are outlined in the agreed proposal. Unless otherwise stated, invoices are due within the agreed payment period. Any applicable taxes, duties, or government charges are the responsibility of the client.
                                        </p>
                                    </div>

                                    <div className="mb-4">
                                        <h3 className="h5 mb-3">4. Intellectual Property</h3>
                                        <p className="mb-0">
                                            Unless otherwise agreed, ownership of custom code, designs, and deliverables created specifically for the client will transfer to the client upon full payment, subject to third-party components and open-source licenses. Krit retains rights to its tools, methods, knowledge, and pre-existing materials.
                                        </p>
                                    </div>

                                    <div className="mb-4">
                                        <h3 className="h5 mb-3">5. Confidentiality & Data Security</h3>
                                        <p className="mb-0">
                                            Both parties agree to protect confidential information shared during the engagement. Krit will implement reasonable technical and organizational safeguards to protect client data but cannot guarantee absolute security against all risks, including unauthorized access beyond our control.
                                        </p>
                                    </div>

                                    <div className="mb-4">
                                        <h3 className="h5 mb-3">6. Warranties & Support</h3>
                                        <p className="mb-0">
                                            Krit will perform services in a professional manner consistent with industry standards. Support terms, including response times and maintenance coverage, will be specified in the relevant agreement. We do not guarantee uninterrupted service or that all software will be free from errors.
                                        </p>
                                    </div>

                                    <div className="mb-4">
                                        <h3 className="h5 mb-3">7. Limitation of Liability</h3>
                                        <p className="mb-0">
                                            Krit shall not be liable for indirect, incidental, or consequential losses, including lost revenue, data loss, or business interruption, except where caused by gross negligence or willful misconduct.
                                        </p>
                                    </div>

                                    <div className="mb-4">
                                        <h3 className="h5 mb-3">8. Termination</h3>
                                        <p className="mb-0">
                                            Either party may terminate the engagement if the other party materially breaches these terms and fails to cure the issue within a reasonable period after notice.
                                        </p>
                                    </div>

                                    <div>
                                        <h3 className="h5 mb-3">9. Governing Law</h3>
                                        <p className="mb-0">
                                            These terms are governed by the laws of the applicable jurisdiction where Krit operates. Any disputes arising from this agreement will be resolved through good-faith discussions before legal action is taken.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default TermsConditionsPage;
